import { engineComponent, NumberUtils, Utils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { Paylines } from "../Paylines";
import { Symbols } from "../Symbols";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { StageController } from "../../Components/StageController";
import { WinAnimator } from "../WinAnimator";
import { FreespinsController } from "./FreespinsController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";
import { AmbientBackground } from "../../Utils/AmbientBackground";
import { WinAnimatorExtended } from "../../CustomComponents/WinAnimatorExtended";
import { WinAnimatorFreespins } from "../../CustomComponents/WinAnimatorFreespins";
import { MachineExtended } from "../../CustomComponents/MachineExtended";
import { Machine } from "../Machine";
import { Winframes } from "../Winframes";
import { CustomUtils } from "../../Utils/CustomUtils";
import { LayoutSwitchElement } from "../../CustomComponents/LayoutSwitchElement";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { ImageElement } from "../../Components/Elements/Graphics/ImageElement";
import { ImageTextElement } from "../../Components/Elements/Texts/ImageTextElement";
import { ImageTextCounterElement } from "../../Components/Elements/Texts/ImageTextCounterElement";
import { Languages } from "../../Utils/Languages";
import { AppContext } from "../../../Common/AppContext";
import { BetManager } from "../../Managers/BetManager";
import { ModuleManager } from "../../Managers/ModuleManager";
import { Tweens } from "../../Components/Effects/Tweens";
import { ReelExtended } from "../../CustomComponents/ReelExtended";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends LayoutContainerElement {
    public static Transition: SwitchElement;
    public static FSPaylinesIndicator: SwitchElement;
    public static ExpandWildReel1FS: SwitchElement;
    public static ExpandWildReel2FS: SwitchElement;
    public static ExpandWildReel3FS: SwitchElement;
    public static ExpandWildReel4FS: SwitchElement;
    public static ExpandWildReel5FS: SwitchElement;

    public messages: LayoutSwitchElement;
    protected currentWins: Array<Communication.Game.IWin>;

    private _controller: FreespinsController;
    private _wasFinished: boolean = false;
    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;
    private _expandTimer: FrameTimerEventEmitter;
    private _copyTimer: FrameTimerEventEmitter;
    private _multiplyTimer: FrameTimerEventEmitter;
    private _paylines: Paylines;
    private _paylinesNumbers: ContainerElement;
    private _fsMessageTimerFS: FrameTimerEventEmitter;
    private _fsMessageTimerFSLayout: FrameTimerEventEmitter;
    private _symbols: Symbols;
    private _machine: MachineExtended;
    private _winAnimator: WinAnimatorFreespins;
    private _winframes: Winframes;
    private _teasing: SwitchElement;
    private _background: SwitchElement;
    private _fsMessageEndTimer: FrameTimerEventEmitter;
    private _symbolsContainer: ContainerElement;
    private _noWinSymbolsContainer: ContainerElement;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this._fsMessageEndTimer = CreateFrameTimer("fsMessageEndTimer");
        this._fsMessageEndTimer.on(FrameTimerEvents.Complete, this.showFsMessageEnd.bind(this));

        this._expandTimer = CreateFrameTimer("expandTimer");
        this._expandTimer.on(FrameTimerEvents.Complete, this.machineStoppedAfterExpand.bind(this));

        this._copyTimer = CreateFrameTimer("copyTimer");
        this._copyTimer.on(FrameTimerEvents.Complete, this.machineStoppedAfterCopy.bind(this));

        this._multiplyTimer = CreateFrameTimer("multiplyTimer");
        this._multiplyTimer.on(FrameTimerEvents.Complete, this.machineStoppedDelayed.bind(this));

        this._fsMessageTimerFS = CreateFrameTimer("fsMessageDelay");
        this._fsMessageTimerFS.on(FrameTimerEvents.Complete, this.showFsMessageFS.bind(this));

        this._fsMessageTimerFSLayout = CreateFrameTimer("fsMessageDelayLayout");
        this._fsMessageTimerFSLayout.on(FrameTimerEvents.Complete, this.showFsMessageFSLayout.bind(this));

        StageController.freespinsStageContainer = this;
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                    this._paylines.reset();
                }

                if (key === "PaylinesNumbers" && this.childs[key] instanceof ContainerElement) {
                    this._paylinesNumbers = this.childs[key];
                }

                if (key === "NoWinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._noWinSymbolsContainer = this.childs[key];
                }

                if (key === "SymbolsContainer" && this.childs[key] instanceof ContainerElement) {
                    this._symbolsContainer = this.childs[key];
                }

                if (key === "FSPaylinesIndicator" && this.childs[key] instanceof SwitchElement) {
                    FreespinsView.FSPaylinesIndicator = this.childs[key];
                }

                if (key === "ExpandWildReel1FS" && this.childs[key] instanceof SwitchElement) {
                    FreespinsView.ExpandWildReel1FS = this.childs[key];
                }

                if (key === "ExpandWildReel2FS" && this.childs[key] instanceof SwitchElement) {
                    FreespinsView.ExpandWildReel2FS = this.childs[key];
                }

                if (key === "ExpandWildReel3FS" && this.childs[key] instanceof SwitchElement) {
                    FreespinsView.ExpandWildReel3FS = this.childs[key];
                }

                if (key === "ExpandWildReel4FS" && this.childs[key] instanceof SwitchElement) {
                    FreespinsView.ExpandWildReel4FS = this.childs[key];
                }

                if (key === "ExpandWildReel5FS" && this.childs[key] instanceof SwitchElement) {
                    FreespinsView.ExpandWildReel5FS = this.childs[key];
                }
                if (key === "Teasing" && this.childs[key] instanceof SwitchElement) {
                    this._teasing = this.childs[key];
                }

                if (key === "Winframes" && this.childs[key] instanceof Winframes) {
                    this._winframes = this.childs[key];
                }

                if (key === "Background" && this.childs[key] instanceof SwitchElement) {
                    this._background = this.childs[key];
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (key === "Machine" && this.childs[key] instanceof MachineExtended) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimatorExtended) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "Messages" && this.childs[key] instanceof LayoutSwitchElement) {
                    this.messages = this.childs[key];
                }

                if (key === "Transition" && this.childs[key] instanceof SwitchElement) {
                    FreespinsView.Transition = this.childs[key];
                }
            }

            if (!Utils.isNullOrUndefined(this._paylinesNumbers)) {
                if (!Utils.isNullOrUndefined(this._paylines)) {
                    this._paylines.addPaylinesNumbers(this._paylinesNumbers);
                    this._paylines.reset();
                }
            }

            if (DEBUG) {
                if (this._paylines == null) {
                    this.log("WARNING no paylines");
                }

                if (this._symbols == null) {
                    this.log("ERROR no symbols");
                }

                if (this._machine == null) {
                    this.log("ERROR no machine");
                }

                if (this._winAnimator == null) {
                    this.log("WARNING no winAnimator");
                }
            }
        }
    }

    initReceived(controller: FreespinsController): void {
        if (DEBUG) {
            this.log("initReceived");
        }
        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    const freespinsInitDataReels = GameManager.getFreespinsInitDataReels();
                    if (freespinsInitDataReels != null) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(MachineExtended.NudgeStopped, this.onNudgeStopped.bind(this));
                        this._machine.on(MachineExtended.NudgeReelStopped, this.onNudgeReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStoppedBeforeNudge.bind(this));
                        this._machine.on(MachineExtended.NudgeMachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            freespinsInitDataReels,
                            this._teasing,
                            this.childs["Background"],
                        );
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.addElementInstance({ Winframes: this._winframes });
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.noWinExpandedSymbolsContainer = this.childs["NoWinExpandedSymbolsContainer"];
                        this._winAnimator.expandedSymbolsContainer = this.childs["ExpandedSymbolsContainer"];
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this._noWinSymbolsContainer,
                            this._symbolsContainer,
                        );
                        this._winAnimator.wildSymbolsContainer = this.childs["WildSymbolsContainer"];
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no base reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        if (FreespinsView.FSPaylinesIndicator != null) {
            FreespinsView.FSPaylinesIndicator.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel1FS != null) {
            FreespinsView.ExpandWildReel1FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel2FS != null) {
            FreespinsView.ExpandWildReel2FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel3FS != null) {
            FreespinsView.ExpandWildReel3FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel4FS != null) {
            FreespinsView.ExpandWildReel4FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel5FS != null) {
            FreespinsView.ExpandWildReel5FS.goToCase("EMPTY");
        }

        this.visible = false;
    }

    initIntro(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        if (FreespinsView.FSPaylinesIndicator != null) {
            FreespinsView.FSPaylinesIndicator.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel1FS != null) {
            FreespinsView.ExpandWildReel1FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel2FS != null) {
            FreespinsView.ExpandWildReel2FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel3FS != null) {
            FreespinsView.ExpandWildReel3FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel4FS != null) {
            FreespinsView.ExpandWildReel4FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel5FS != null) {
            FreespinsView.ExpandWildReel5FS.goToCase("EMPTY");
        }

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);

        if (CustomUtils.hasExpandWild(GameManager.freespinsResponse)) {
            this._winAnimator.wildExpand_new(true);
        }
        if (CustomUtils.hasCopyWild(GameManager.freespinsResponse.customData)) {
            this._winAnimator.wildCopy_new(true);
        }
        if (CustomUtils.hasMultiplyWild(GameManager.freespinsResponse)) {
            this._winAnimator.wildMultiply_new(true);
        }

        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);

        this.visible = true;

        AmbientBackground.changeAmbientBackground("color-1", 0);

        // this.retrigger();

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSEndWait", 300);
            PlayList.play("SND_FSEnd");

            let totalWin = GameManager.freespinsResponse.totalWin;
            let win: number | string;

            if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
                ImageTextCounterElement.Round = true;
                win = parseInt(NumberUtils.devide(totalWin, BetManager.CoinSize).toString());
            } else {
                ImageTextCounterElement.Round = false;
                win = Languages.formatText(Languages.FormatMoney, totalWin.toString());
            }

            let numberElement = this.messages.getChildElementByName("FsWinCount") as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElement)) {
                numberElement.setText(win.toString());
            }

            if (!Utils.isNullOrUndefined(this.messages)) {
                this.messages.goToCase("SHOW_FS_END");
            }

            this.showFsMessageEnd();
        } else {
            PlayList.loop("SND_FSLoop");
        }
    }

    protected layoutChanged() {
        if (ModuleManager.freespinsActive()) {
            if (!ReelExtended.Tease) {
                this._fsMessageTimerFSLayout.start(0);
            }
        }
    }

    spin(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        if (!Utils.isNullOrUndefined(this.messages)) {
            if (
                this.messages.getCurrentCase() == "SHOW_FS" ||
                this.messages.getCurrentCase() == "SHOW_FS_END" ||
                this.messages.getCurrentCase() == "SHOW_FS_IDLE"
            ) {
                this.messages.goToCase("HIDE_FS");
            }
        }

        if (FreespinsView.FSPaylinesIndicator != null) {
            FreespinsView.FSPaylinesIndicator.goToCase("EMPTY");
        }

        PlayList.loop("SND_FSLoop");

        const spinBitmask = this.calculateSpinBitmask();
        this._machine.spinStart(this._winAnimator.reset(true), true, this._winAnimator.currentSymbols, spinBitmask);
    }

    stop(): void {
        this._machine.spinStopFS(null, true);
    }

    startReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.reset(true);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStopFS(null, false, true);
    }

    endReceived(): void {}

    onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    onNudgeStopped(): void {
        this._winAnimator.onNudgeStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    onNudgeReelStopped(reelIndex: number): void {
        this._winAnimator.onNudgeReelStopped(GameManager.freespinsResponse.screen.reels, reelIndex);
    }

    machineStoppedBeforeNudge(): void {
        if (CustomUtils.hasNudgeSymbolsFS()) {
            this._machine.nudgeSpin();
            this._controller.machineStoppedBeforeNudge();
        } else {
            this.machineStopped();
        }
    }

    machineStopped(): void {
        if (CustomUtils.hasExpandWild(GameManager.freespinsResponse)) {
            let delay = this._winAnimator.wildExpand_new();
            this._expandTimer.start(delay);
        } else if (CustomUtils.hasCopyWild(GameManager.freespinsResponse.customData)) {
            let delay = this._winAnimator.wildCopy_new();
            this._copyTimer.start(delay);
        } else if (CustomUtils.hasMultiplyWild(GameManager.freespinsResponse)) {
            let delay = this._winAnimator.wildMultiply_new();
            this._multiplyTimer.start(delay);
        } else {
            this.machineStoppedDelayed();
        }
    }

    machineStoppedAfterExpand(): void {
        this._expandTimer.stop();

        if (CustomUtils.hasCopyWild(GameManager.freespinsResponse.customData)) {
            let delay = this._winAnimator.wildCopy_new();
            this._copyTimer.start(delay);
        } else if (CustomUtils.hasMultiplyWild(GameManager.freespinsResponse)) {
            let delay = this._winAnimator.wildMultiply_new();
            this._multiplyTimer.start(delay);
        } else {
            this.machineStoppedDelayed();
        }
    }

    machineStoppedAfterCopy(): void {
        this._copyTimer.stop();

        if (CustomUtils.hasMultiplyWild(GameManager.freespinsResponse)) {
            let delay = this._winAnimator.wildMultiply_new();
            this._multiplyTimer.start(delay);
        } else {
            this.machineStoppedDelayed();
        }
    }

    machineStoppedDelayed(): void {
        this._expandTimer.stop();
        this._copyTimer.stop();
        this._multiplyTimer.stop();

        this._wasFinished = false;
        this._controller.machineStopped();
        if (this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin)) {
            PlayList.stop("SND_FSLoop");
        }

        if (GameManager.freespinsResponse.currentWin === 0) {
            if (this.isLastFreespin()) {
                PlayList.stop("SND_FSLoop");
                PlayList.loop("SND_FSEndWait", 300);
                PlayList.play("SND_FSEnd");

                this._fsMessageEndTimer.start(30);
            }
        }
    }

    hasMultiplyWildWithWin(wins: Array<Communication.Game.IWin>): boolean {
        this.currentWins = wins;
        let hasCashWin = CustomUtils.hasCashWin(this.currentWins);

        const customData = GameManager.freespinsResponse.customData;
        if (!Utils.isNullOrUndefined(customData)) {
            if (hasCashWin) {
                for (let i = 0; i < this.currentWins.length; i++) {
                    if (this.currentWins[i].symbols.indexOf(CustomUtils.SymbolWildMultiply) > -1) {
                        if (customData.hasOwnProperty("wildSymbols")) {
                            for (let j: number = 0; j < customData.wildSymbols.length; j++) {
                                if (customData.wildSymbols[j].type == "multiplier") {
                                    return true;
                                }
                            }
                        }
                    }
                }
            }
        }

        return false;
    }

    finishWinCalculation(): void {
        this._wasFinished = true;
        this._controller.winCalculationFinished();
    }

    finishWinAnimator(): void {
        this._controller.allWinsFinished();

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSEndWait", 300);
            PlayList.play("SND_FSEnd");

            this._fsMessageEndTimer.start(30);
        } else {
            PlayList.loop("SND_FSLoop");
        }

        this.retrigger();
    }

    intro(long: boolean = false): void {
        StageController.freespinStage = true;
        this.visible = true;

        if (FreespinsView.Transition != null) {
            this.addChild(FreespinsView.Transition);
        }

        if (FreespinsView.ExpandWildReel1FS != null) {
            FreespinsView.ExpandWildReel1FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel2FS != null) {
            FreespinsView.ExpandWildReel2FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel3FS != null) {
            FreespinsView.ExpandWildReel3FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel4FS != null) {
            FreespinsView.ExpandWildReel4FS.goToCase("EMPTY");
        }

        if (FreespinsView.ExpandWildReel5FS != null) {
            FreespinsView.ExpandWildReel5FS.goToCase("EMPTY");
        }

        this.allSwitchElementToCase("NORMAL");
        if (FreespinsView.FSPaylinesIndicator != null) {
            FreespinsView.FSPaylinesIndicator.goToCase("INIT");
        }
        this._introDelay.start(60);
    }

    introFinished(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        this.visible = true;

        AmbientBackground.changeAmbientBackground("color-1", 0);

        PlayList.loop("SND_FSLoop");

        this._controller.introFinished();
    }

    outro(): void {
        if (FreespinsView.Transition != null) {
            this.addChild(FreespinsView.Transition);
            FreespinsView.Transition.goToCase("OUT");
        }
        StageController.freespinStage = true;

        this.visible = true;

        PlayList.stop("SND_FSLoop");
        PlayList.stop("SND_FSEndWait");
        PlayList.play("SND_FSTransOut");

        if (!Utils.isNullOrUndefined(this.messages)) {
            if (
                this.messages.getCurrentCase() == "SHOW_FS" ||
                this.messages.getCurrentCase() == "SHOW_FS_END" ||
                this.messages.getCurrentCase() == "SHOW_FS_IDLE"
            ) {
                this.messages.goToCase("HIDE_FS");
            }
        }

        this._winAnimator.reset(false);
        this._outroDelay.start(30);
    }

    outroFinished(): void {
        StageController.freespinStage = false;

        AmbientBackground.changeAmbientBackground("base", 45);

        this.visible = false;

        this.allSwitchElementToCase("EMPTY");

        this._winAnimator.resetTimer();
        this._controller.outroFinished();
    }

    enable(): void {}

    public showFsMessageFS(): void {
        this._fsMessageTimerFS.stop();
        // this.messages.goToCase('SHOW_FS');
        this.retrigger();
    }

    public showFsMessageFSLayout(): void {
        this._fsMessageTimerFSLayout.stop();
        this.retrigger();
    }

    private retrigger(): void {
        ReelExtended.Tease = false;

        if (!this.isLastFreespin()) {
            if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                        if (this.messages != null) {
                            const customData = GameManager.freespinsResponse.wins[i].customData;

                            if (!Utils.isNullOrUndefined(customData)) {
                                if (customData.hasOwnProperty("count")) {
                                    this.messages.goToCase("SHOW_FS");

                                    let bonusWinCount = this.messages.getChildElementByName(
                                        "Number" + customData.count,
                                    ) as ImageElement;
                                    if (!Utils.isNullOrUndefined(bonusWinCount)) {
                                        bonusWinCount.visible = true;
                                        Tweens.removeTweens(bonusWinCount, "all");
                                        Tweens.customTween(bonusWinCount, {
                                            tween: "alpha",
                                            tweenValues: [0, 1],
                                            tweenDuration: [10],
                                            tweenLoop: false,
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }

    private allSwitchElementToCase(caseType: string): void {
        for (let key in this.childs) {
            if (this.childs[key] instanceof SwitchElement) {
                let elem: SwitchElement = this.childs[key];

                if (elem.hasCase(caseType)) {
                    elem.goToCase(caseType);
                }
            }
        }
    }

    protected showFsMessageEnd(): void {
        this._fsMessageEndTimer.stop();

        let totalWin = GameManager.freespinsResponse.totalWin;
        let win: number | string;

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            win = parseInt(NumberUtils.devide(totalWin, BetManager.CoinSize).toString());
        } else {
            ImageTextCounterElement.Round = false;
            win = Languages.formatText(Languages.FormatMoney, totalWin.toString());
        }

        let numberElement = this.messages.getChildElementByName("FsWinCount") as ImageTextElement;
        if (!Utils.isNullOrUndefined(numberElement)) {
            numberElement.setText(win.toString());
        }

        if (!Utils.isNullOrUndefined(this.messages)) {
            this.messages.goToCase("SHOW_FS_END");
        }
    }

    public calculateSpinBitmask(): number {
        // return (1 << this._winAnimator.reelCount) - 1;
        return 0b11111;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/